{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-210100",
  "definition": "[210100] Sub-classification of assets, liabilities and equity, by current/non-current method",
  "sheetId": "SubClassificationOfAssetsLiabilitiesEquity",
  "label": "Sub-classification of Assets, Liabilities and Equity (MPERS)",
  "taxonomy": "FS-MPERS",
  "controls": [
    {
      "qname": "ssmt-mpers:DisclosureOnSubclassificationOfAssetsLiabilitiesAndEquityAbstract",
      "label": "Statement on sub-classification of assets, liabilities and equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 1,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:SubclassificationOfAssetsLiabilitiesAndEquityAbstract",
      "label": "Sub-classification of assets, liabilities and equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:PropertyPlantAndEquipmentAbstract",
      "label": "Property, Plant and Equipment",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:LandAndBuildingsAbstract",
      "label": "Land and buildings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LandAbstract",
      "label": "Land",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:FreeholdLand",
      "label": "Freehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LongtermLeaseholdLand",
      "label": "Long term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ShorttermLeaseholdLand",
      "label": "Short term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:Land",
      "label": "Total land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true,
        "sectionBoundary": 5
      }
    },
    {
      "qname": "ssmt-mpers:BuildingAbstract",
      "label": "Buildings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:BuildingOnFreeholdLand",
      "label": "Building on freehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:BuildingOnLongtermLeaseholdLand",
      "label": "Building on long term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:BuildingOnShorttermLeaseholdLand",
      "label": "Building on short term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LeasedProperties",
      "label": "Leased properties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:Buildings",
      "label": "Total buildings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:LandAndBuildings",
      "label": "Total land and buildings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true,
        "sectionBoundary": 4
      }
    },
    {
      "qname": "ifrs-smes:Machinery",
      "label": "Machinery",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:Vehicles",
      "label": "Vehicles",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OfficeEquipmentFixtureAndFittings",
      "label": "Office equipment, fixture and fittings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:PlantAndEquipment",
      "label": "Plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ConstructionInProgress",
      "label": "Construction in progress/Asset work-in progress",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherPropertyPlantAndEquipment",
      "label": "Other property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:PropertyPlantAndEquipment",
      "required": true,
      "label": "Total property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true,
        "sectionBoundary": 3
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentPropertyAbstract",
      "label": "Investment Property",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentPropertyFreeholdLandAndBuilding",
      "label": "Freehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentPropertyLongtermLeaseholdLand",
      "label": "Long term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentPropertyShorttermLeaseholdLand",
      "label": "Short term leasehold land",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentPropertyBuildingUnderConstruction",
      "label": "Buildings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherInvestmentProperty",
      "label": "Other investment property",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:InvestmentProperty",
      "required": true,
      "label": "Total investment properties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:IntangibleAssetsAndGoodwillAbstract",
      "label": "Intangible assets and goodwill",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:IntangibleAssetsOtherThanGoodwillAbstract",
      "label": "Intangible assets other than goodwill",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CopyrightsPatentsAndOtherIndustrialPropertyRightsServiceAndOperatingRights",
      "label": "Copyrights, patents and other industrial property rights, service and operating rights",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherIntangibleAssets",
      "label": "Other intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:IntangibleAssetsOtherThanGoodwill",
      "label": "Total intangible assets other than goodwill",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:Goodwill",
      "label": "Goodwill",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:IntangibleAssetsAndGoodwill",
      "required": true,
      "label": "Total intangible assets and goodwill",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:InvestmentsInSubsidiariesAbstract",
      "label": "Investments in subsidiaries",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentsInSubsidiariesUnquotedSharesNetOfImpairmentLosses",
      "label": "Unquoted shares, net of impairment losses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentInSubsidiariesQuotedSharesInMalaysia",
      "label": "Quoted shares in Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentInSubsidiariesQuotedSharesOutsideMalaysia",
      "label": "Quoted shares outside Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentsInSubsidiariesOtherInvestmentsNetOfImpairmentLosses",
      "label": "Other investments in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentInSubisidiaries",
      "required": true,
      "label": "Total investments in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:InvestmentsInAssociatesAbstract",
      "label": "Investments in associates",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentsInAssociatesUnquotedSharesNetOfImpairmentLosses",
      "label": "Unquoted shares, net of impairment losses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentInAssociatesQuotedSharesInMalaysia",
      "label": "Quoted shares in Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentInAssociatesQuotedSharesOutsideMalaysia",
      "label": "Quoted shares outside Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentsInAssociatesShareOfPostAcquisitionProfitsAndReserves",
      "label": "Share of post-acquisition profits and reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentsInAssociatesOtherInvestmentsNetOfImpairmentLosses",
      "label": "Other investments in associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:InvestmentsInAssociates",
      "required": true,
      "label": "Total investments in associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:InvestmentsInJointVenturesAbstract",
      "label": "Investments in joint ventures",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentsInJointVentureUnquotedSharesNetOfImpairmentLosses",
      "label": "Unquoted shares, net of impairment losses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentInJointVenturesQuotedSharesInMalaysia",
      "label": "Quoted shares in Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentInJointVenturesQuotedSharesOutsideMalaysia",
      "label": "Quoted shares outside Malaysia",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentsInJointVentureShareOfPostAcquisitionProfitsAndReserves",
      "label": "Share of post-acquisition profits and reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:InvestmentsInJointVentureOtherInvestment",
      "label": "Other investments in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:InvestmentsInJointVentures",
      "required": true,
      "label": "Total investments in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:TradeAndOtherNoncurrentReceivablesAbstract",
      "label": "Trade and other non-current receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentTradeReceivablesAbstract",
      "label": "Non-current trade receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradeReceivablesDueFromHoldingCompany",
      "label": "Trade receivables due from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradeReceivablesDueFromSubsidiaries",
      "label": "Trade receivables due from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradeReceivablesDueFromAssociates",
      "label": "Trade receivables from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradeReceivablesDueFromJointVentures",
      "label": "Trade receivables due from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradeReceivablesDueFromRelatedParties",
      "label": "Trade receivables due from other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentTradeReceivables",
      "label": "Other non-current trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradeReceivables",
      "label": "Total non-current trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentReceivablesAbstract",
      "label": "Other non-current receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentReceivablesDueFromRelatedPartiesAbstract",
      "label": "Other non-current receivables due from related parties",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentReceivablesDueFromHoldingCompany",
      "label": "Other receivables due from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentReceivablesDueFromSubsidiaries",
      "label": "Other receivables due from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentReceivablesDueFromAssociates",
      "label": "Other receivables due from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentReceivablesDueFromJointVentures",
      "label": "Other receivables due from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentReceivablesDueFromOtherRelatedParties",
      "label": "Other receivables due from other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentReceivablesDueFromRelatedParties",
      "label": "Total other non-current receivables due from related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentNontradeReceivablesAbstract",
      "label": "Non-current non-trade receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentNontradePrepaymentAndAccruedIncome",
      "label": "Accrued income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentNontradeLeaseAndHirePurchaseReceivables",
      "label": "Lease and hire purchase receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentNontradeMiscellaneous",
      "label": "Other non-current non-trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentNontradeReceivables",
      "label": "Total other non-current non-trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentReceivables",
      "label": "Total other non-current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentReceivables",
      "required": true,
      "label": "Total trade and other non-current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:InventoriesAbstract",
      "label": "Inventories",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:RawMaterials",
      "label": "Raw materials",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:WorkInProgress",
      "label": "Work in progress",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:FinishedGoods",
      "label": "Finished goods",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:SpareParts",
      "label": "Spare parts",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherInventories",
      "label": "Other inventories",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:InventoriesTotal",
      "required": true,
      "label": "Total inventories",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:TradeAndOtherCurrentReceivablesAbstract",
      "label": "Trade and other current receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradeReceivablesAbstract",
      "label": "Current trade receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradeReceivablesDueFromContractCustomers",
      "label": "Trade receivables due from contract customers",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradeReceivablesDueFromHoldingCompany",
      "label": "Trade receivables due from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradeReceivablesDueFromSubsidiaries",
      "label": "Trade receivables due from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradeReceivablesDueFromAssociates",
      "label": "Trade receivables due from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradeReceivablesDueFromJointVentures",
      "label": "Trade receivables due from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradeReceivablesDueFromRelatedParties",
      "label": "Trade receivables due from other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentTradeReceivables",
      "label": "Other current trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradeReceivables",
      "label": "Total current trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentReceivablesAbstract",
      "label": "Other current receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentReceivablesDueFromRelatedPartiesAbstract",
      "label": "Current other receivables due from related parties",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentReceivablesDueFromHoldingCompany",
      "label": "Other receivables due from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentReceivablesDueFromSubsidiaries",
      "label": "Other receivables due from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentReceivablesDueFromAssociates",
      "label": "Other receivables due from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentReceivablesDueFromJointVentures",
      "label": "Other receivables due from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentReceivablesDueFromOtherRelatedParties",
      "label": "Other receivables due from other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentReceivablesDueFromRelatedParties",
      "label": "Total current other receivables due from related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentPrepaymentsAndCurrentAccruedIncomeAbstract",
      "label": "Current prepayments and current accrued income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPrepayments",
      "label": "Prepayments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentAccruedIncome",
      "label": "Accrued income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPrepaymentsAndCurrentAccruedIncome",
      "label": "Total current prepayments and current accrued income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentNontradeReceivablesAbstract",
      "label": "Current non-trade receivables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentNontradeFinanceIncomeReceivable",
      "label": "Interest receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentNontradeDeposits",
      "label": "Deposits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentNontradeDividendReceivables",
      "label": "Dividend receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentNontradeLeaseAndHirePurchaseReceivables",
      "label": "Lease and hire purchase receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentMiscellaneousNontradeReceivables",
      "label": "Other current non-trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentNontradeReceivables",
      "label": "Total non-trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentReceivables",
      "label": "Total other current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:TradeAndOtherCurrentReceivables",
      "required": true,
      "label": "Total trade and other current receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CashAndCashEquivalentsAbstract",
      "label": "Cash and cash equivalents",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CashAbstract",
      "label": "Cash",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CashOnHand",
      "label": "Cash in hand",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:BalancesWithBanks",
      "label": "Balances with banks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:Cash",
      "label": "Total cash",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CashEquivalentsAbstract",
      "label": "Cash equivalents",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:DepositsAndPlacementsWithLicensedBanks",
      "label": "Deposits placed with licensed banks",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:DepositsPlacedWithOtherCorporations",
      "label": "Deposit placed with other corporations",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:FixedDepositsWithFinancialInstitutions",
      "label": "Fixed deposits with financial institutions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CashEquivalentsWithOtherFinancialInstitutions",
      "label": "Cash equivalents with other financial institutions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShorttermDepositsClassifiedAsCashEquivalents",
      "label": "Short-term deposits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShorttermInvestmentsClassifiedAsCashEquivalents",
      "label": "Short-term investments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:BankingArrangementsClassifiedAsCashEquivalents",
      "label": "Other banking arrangements",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CashEquivalents",
      "label": "Total cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherCashAndCashEquivalents",
      "label": "Other cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:CashAndBankBalances",
      "required": true,
      "label": "Total cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:IssuedCapitalAbstract",
      "label": "Issued capital",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CapitalFromOrdinaryShares",
      "label": "Capital from ordinary shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CapitalFromRedeemablePreferenceShares",
      "label": "Capital from redeemable preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CapitalFromNonredeemablePreferenceShares",
      "label": "Capital from non-redeemable preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:IssuedCapital",
      "required": true,
      "label": "Total issued capital",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ReservesAbstract",
      "label": "Reserves",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NondistributableReservesAbstract",
      "label": "Non-distributable",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CapitalReserve",
      "label": "Capital reserve",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ReserveOfExchangeDifferencesOnTranslation",
      "label": "Foreign currency translation reserve",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:RevaluationSurplus",
      "label": "Revaluation surplus",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNondistributableReserves",
      "label": "Other non-distributable reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NondistributableReserves",
      "label": "Total non-distributable reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:DistributableReservesAbstract",
      "label": "Distributable",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherDistributableReserve",
      "label": "Other distributable reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:DistributableReseves",
      "label": "Total distributable reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherReserves",
      "required": true,
      "label": "Total reserves",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:EquityOtherComponentsAbstract",
      "label": "Equity - others components",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:PerpetualSukuk",
      "label": "Perpetual sukuk",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:EquityComponentOfIrredeemableConvertibleUnsecuredLoanStocks",
      "label": "Equity component of Irredeemable Convertible Unsecured Loan Stocks (ICULS)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:EquityComponentOfPreferenceShares",
      "label": "Equity component of preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:EquityComponentsOfOtherFinancialInstruments",
      "label": "Equity components of other financial instruments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherComponentsOfEquity",
      "required": true,
      "label": "Total equity - other components",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentBorrowingsAbstract",
      "label": "Non-current loans and borrowings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentPortionOfNoncurrentSecuredBankLoansReceived",
      "label": "Secured bank loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentPortionOfNoncurrentUnsecuredBankLoansReceived",
      "label": "Unsecured bank loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentPortionOfSecuredConvertibleNotes",
      "label": "Secured convertible notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentPortionOfUnsecuredConvertibleNotes",
      "label": "Unsecured convertible notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentPortionOfRedeemablePreferenceShares",
      "label": "Redeemable preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentPortionOfFinanceLeaseLiabilities",
      "label": "Finance lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentPortionOfLoanFromHoldingCompany",
      "label": "Loan from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentPortionOfLoanFromSubsidiaries",
      "label": "Loan from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentPortionOfLoanFromAssociates",
      "label": "Loan from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentPortionOfLoanFromJointVentures",
      "label": "Loan from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentPortionOfLoanFromOtherRelatedCompanies",
      "label": "Loan from other related companies",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentSecuredBankLoans",
      "label": "Other secured bank facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentUnsecuredBankLoans",
      "label": "Other unsecured bank facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentPortionOfOtherNoncurrentBorrowings",
      "label": "Other non-current borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentBorrowings",
      "required": true,
      "label": "Total non-current borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentEmployeeBenefitLiabilitiesAbstract",
      "label": "Non-current employee benefits",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CashSettledShareBasedPaymentLiability",
      "label": "Cash-settled share-based payment liability",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:EmploymentTerminationBenefits",
      "label": "Employment termination benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ProvisionForUnconsumedLeave",
      "label": "Provision for unconsumed leave",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:DefinedContributionPlan",
      "label": "Defined contribution plan",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:DefinedBenefitPlan",
      "label": "Defined benefit plan",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherEmployeeBenefitLiabilities",
      "label": "Other non-current employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentProvisionsForEmployeeBenefits",
      "required": true,
      "label": "Total non-current employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentProvisionsAbstract",
      "label": "Non-current provisions",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:LongtermWarrantyProvision",
      "label": "Warranty provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:LongtermRestructuringProvision",
      "label": "Restructuring provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:LongtermLegalProceedingsProvision",
      "label": "Legal proceedings provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:LongtermOnerousContractsProvision",
      "label": "Onerous contracts provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:LongtermProvisionForDecommissioningRestorationAndRehabilitationCosts",
      "label": "Provision for decommissioning, restoration and rehabilitation costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:LongtermMiscellaneousOtherProvisions",
      "label": "Other non-current provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentProvisions",
      "required": true,
      "label": "Total non-current provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:TradeAndOtherNoncurrentPayablesAbstract",
      "label": "Trade and other non-current payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradePayablesAbstract",
      "label": "Non-current trade payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradePayablesDueToHoldingCompany",
      "label": "Trade payables due to holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradePayablesDueToSubsidiaries",
      "label": "Trade payables due to subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradePayablesDueToAssociates",
      "label": "Trade payables due to associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradePayablesDueToJointVentures",
      "label": "Trade payables due to joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentTradePayablesDueToOtherRelatedParties",
      "label": "Trade payables due to other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentTradePayables",
      "label": "Other non-current trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentPayablesToTradeSuppliers",
      "label": "Total non-current trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentPayablesAbstract",
      "label": "Other non-current payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentPayablesDueToRelatedPartiesAbstract",
      "label": "Other non-current payables due to related parties",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentTradePayablesDueToHoldingCompany",
      "label": "Other payables due to holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentTradePayablesDueToSubsidiaries",
      "label": "Other payables due to subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentTradePayablesDueToAssociates",
      "label": "Other payables due to associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentTradePayablesDueToJointVentures",
      "label": "Other payables due to joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentPayablesDueToRelatedCompanies",
      "label": "Other payables due to other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentPayablesDueToRelatedParties",
      "label": "Total other non-current payables due to related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentNontradePayablesAbstract",
      "label": "Non-current non-trade payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentNontradeDeferredIncome",
      "label": "Deferred income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentNontradeAccruals",
      "label": "Accruals",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentNontradeRetentionPayables",
      "label": "Retention payable",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentNontradePayables",
      "label": "Other non-current non-trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:NoncurrentNontradePayables",
      "label": "Total non-current non-trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherNoncurrentPayables",
      "label": "Total other non-current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:NoncurrentPayables",
      "required": true,
      "label": "Total trade and other non-current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentBorrowingsAbstract",
      "label": "Current borrowings",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentSecuredBankLoansReceivedAndCurrentPortionOfNoncurrentSecuredBankLoansReceived",
      "label": "Secured bank loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentUnsecuredBankLoansReceivedAndCurrentPortionOfNoncurrentUnsecuredBankLoansReceived",
      "label": "Unsecured bank loans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrenPortionOfSecuredConvertibleNotes",
      "label": "Secured convertible notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentPortionOfUnsecuredConvertibleNotes",
      "label": "Unsecured convertible notes",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentPortionOfNoncurrentSecuredBankOverdrafts",
      "label": "Secured bank overdrafts",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentPortionOfNoncurrentUnsecuredBankOverdrafts",
      "label": "Unsecured bank overdrafts",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPortionOfRedeemablePreferenceShares",
      "label": "Redeemable preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentPortionOfFinanceLeaseLiabilities",
      "label": "Finance lease liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentPortionOfLoanFromHoldingCompany",
      "label": "Loan from holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPortionOfLoanFromSubsidiaries",
      "label": "Loan from subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPortionOfLoanFromAssociates",
      "label": "Loan from associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPortionOfLoanFromJointVentures",
      "label": "Loan from joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentPortionOfLoanFromOtherRelatedCompanies",
      "label": "Loan from other related companies",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentPortionOfNoncurrentSecuredOtherBankLoanReceived",
      "label": "Other secured bank facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentPortionOfNoncurrentUnsecuredOtherBankLoansReceived",
      "label": "Other unsecured bank facilities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPortionOfMiscellaneousBorrowings",
      "label": "Other current borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShorttermBorrowings",
      "required": true,
      "label": "Total current loans and borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentEmployeeBenefitLiabilitiesAbstract",
      "label": "Current employee benefits",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentCashSettledShareBasedPaymentLiability",
      "label": "Cash-settled share-based payment liability",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentEmploymentTerminationBenefits",
      "label": "Employment termination benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentProvisionForUnconsumedLeave",
      "label": "Provision for unconsumed leave",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentDefinedContributionPlan",
      "label": "Defined contribution plan",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentDefinedBenefitPlan",
      "label": "Defined benefit plan",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentOtherEmployeeBenefitLiabilities",
      "label": "Other current employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CurrentProvisionsForEmployeeBenefits",
      "required": true,
      "label": "Total current employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CurrentProvisionsAbstract",
      "label": "Current provisions",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShorttermWarrantyProvision",
      "label": "Warranty provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShorttermRestructuringProvision",
      "label": "Restructuring provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShorttermLegalProceedingsProvision",
      "label": "Legal proceedings provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:ShorttermOnerousContractsProvision",
      "label": "Onerous contracts provision",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ShorttermProvisionForDecommissioningRestorationAndRehabilitationCosts",
      "label": "Provision for decommissioning, restoration and rehabilitation costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherShorttermProvisions",
      "label": "Other current provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CurrentProvisions",
      "required": true,
      "label": "Total current provisions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:TradeAndOtherCurrentPayablesAbstract",
      "label": "Trade and other current payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CurrentTradePayablesAbstract",
      "label": "Current trade payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradePayableDueToContractCustomer",
      "label": "Trade payable due to contract suppliers",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradePayablesDueToHoldingCompany",
      "label": "Trade payables due to holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradePayablesDueToSubsidiaries",
      "label": "Trade payables due to subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradePayablesDueToAssociates",
      "label": "Trade payables due to associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradePayablesDueToJointVentures",
      "label": "Trade payables due to joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentTradePayablesDueToRelatedCompanies",
      "label": "Trade payables due to other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentTradePayables",
      "label": "Other current trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:TradeAndOtherCurrentPayablesToTradeSuppliers",
      "label": "Total current trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:OtherCurrentPayablesAbstract",
      "label": "Other current payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPayablesDueToRelatedPartiesAbstract",
      "label": "Other current payables due to related parties",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPayablesDueToHoldingCompany",
      "label": "Other payables due to holding company",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPayablesDueToSubsidiaries",
      "label": "Other payables due to subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPayablesDueToAssociates",
      "label": "Other payables due to associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPayablesDueToJointVentures",
      "label": "Other payables due to joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPayablesDueToOtherRelatedParties",
      "label": "Other payables due to other related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPayablesDueToRelatedParties",
      "label": "Total other current payables due to related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:CurrentNontradePayablesAbstract",
      "label": "Current non-trade payables",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 5,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentNontradeDeferredIncome",
      "label": "Deferred income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentNontradeAccruals",
      "label": "Accruals",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentNontradeRetentionPayable",
      "label": "Retention payable",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentNontradePayables",
      "label": "Other current non-trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": false,
        "calculated": false,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:CurrentNontradePayables",
      "label": "Total current non-trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:OtherCurrentPayables",
      "label": "Total other current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-smes:TradeAndOtherCurrentPayables",
      "required": true,
      "label": "Total trade and other current payables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      }
    }
  ]
}
